import { Image } from 'antd';
import styled from 'styled-components';

export default styled(Image)`
	// Add your styles here
`;
